import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useA11yTokens } from '../../hooks/useA11yTokens';

const Loading: React.FC = () => {
    const { t } = useTranslation();
    const theme4dTokens = useA11yTokens();
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                bgcolor: theme4dTokens.bg,
            }}
        >
            <CircularProgress sx={{ color: theme4dTokens.accent }} size={48} thickness={4} />
            <Typography sx={{ color: theme4dTokens.muted, fontWeight: 500 }}>{t('loading.text')}</Typography>
        </Box>
    );
};

export default Loading;
